import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

/**
 * Whether the Suggestions panel can be used while the content is in view mode, on a published page
 * or a live doc. The suggested edits experiment is the kill switch for the view mode subgate.
 *
 * Check any preconditions first, so users they exclude aren't exposed to the experiment and gate.
 */
export const isViewModeSuggestionsEnabled = (): boolean =>
	// eslint-disable-next-line confluence-feature-gating/no-preconditioning -- The suggested edits experiment is the kill switch for the view mode Suggestions panel subgate.
	expValEquals('platform_editor_ai_content_suggested_edits', 'isEnabled', true) &&
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- View mode Suggestions panel subgate.
	fg('confluence_suggestions_panel_view_mode');
